import * as Posts from "./main/index";

export const text = Object.values(Posts)
